import React, { useState, useEffect } from 'react';
import LcAccordion from '../../../../components/Generic/LcAccordion';
import LcLoading from '../../../../components/Generic/LcLoading';
import { SolicitationView } from '../../../../models/SolicitationView';
import CustomerService from '../../../../services/CustomerService/CustomerService';
import Parse from 'html-react-parser';

interface Props {
    solicitation: SolicitationView
}

const SolicitationFaq: React.FC<Props> = (props) => {
    const customerService = new CustomerService(props);
    const [loading, setLoading] = useState<boolean>(true)
    const [faq, setFaq] = useState<string>('');

    useEffect(() => {
        if (props.solicitation) {
            const getFaq = async () => {
                setLoading(true);
                
                try {
                    const customerResponse = await customerService.GetById(props.solicitation.idCustomer);
                    setFaq(customerResponse.data[0].textConnection);
                }
                catch (error) {
                    console.warn(error);
                }

                setLoading(false);
            }

            getFaq();
        }
    }, [props.solicitation])

    return (
        <>
            {
                faq &&
                <div className='divFaq'>
                    <LcAccordion title='FAQ (Conexões)' visible={false} iconNormal>
                        <LcLoading label='carregando...' loading={loading}>
                            <div className='faq' style={{ lineHeight: '25px', textAlign: 'start' }}>
                                {faq && Parse(faq)}
                            </div>
                        </LcLoading>
                    </LcAccordion>
                </div>
            }
        </>
    );
}

export default SolicitationFaq;